import { useAxios } from '../base/useAxios';
import type { APIResponse } from '@/models/response/response';
import type {
    DeploymentSettings,
    DeploymentUserOption,
} from '@/models/deploymentSettings';

export function useDeploymentSettingsApi() {
    const api = useAxios();

    function getDeploymentSettings(): Promise<APIResponse<DeploymentSettings>> {
        return api.$get('/deployment-settings');
    }

    function getDeploymentSettingsUsers(): Promise<APIResponse<DeploymentUserOption[]>> {
        return api.$get('/deployment-settings/users');
    }

    function saveDeploymentSettings(
        data: DeploymentSettings
    ): Promise<APIResponse<DeploymentSettings>> {
        return api.$put('/deployment-settings', data);
    }

    return {
        getDeploymentSettings,
        getDeploymentSettingsUsers,
        saveDeploymentSettings,
    };
}
